// Client Supabase pour l'app web (côté navigateur).
// La clé `anon` est publique — l'isolation tenant est assurée par les politiques RLS.

import { createClient, type SupabaseClient } from '@supabase/supabase-js';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  throw new Error(
    'Variables d\'environnement Supabase manquantes : VITE_SUPABASE_URL et VITE_SUPABASE_ANON_KEY. ' +
      'Copier .env.example en .env et lancer `pnpm supabase:start`.',
  );
}

export const supabase: SupabaseClient = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    // Désactivé volontairement : l'app s'authentifie par mot de passe. Les seuls
    // jetons transmis par URL sont les liens d'invitation / réinitialisation, qui
    // arrivent en fragment implicite (#access_token=…) et sont traités
    // explicitement par DefinirMotDePassePage. Laisser detectSessionInUrl actif
    // en mode PKCE provoquait une course qui effaçait la session fraîchement posée.
    detectSessionInUrl: false,
    flowType: 'pkce',
    // Verrou no-op : évite les deadlocks de l'API navigator.locks (multi-onglets,
    // rechargements). Application mono-utilisateur → pas de coordination cross-tab requise.
    lock: (_name, _acquireTimeout, fn) => fn(),
  },
  global: {
    headers: {
      'X-Client-Info': 'imp-toiture-crm-web',
    },
  },
});
